import PeripheralBridge from '../../utils/peripheralBridge'
import { isTestMode } from '../../VNAndroidSDK/Utils'

export const startScanner = () => {
  const bridgeInstance = PeripheralBridge.getBridge()
  if (!bridgeInstance) return

  bridgeInstance.call('startScanner')
}

export const stopScanner = () => {
  const bridgeInstance = PeripheralBridge.getBridge()
  if (!bridgeInstance) return

  bridgeInstance.call('stopScanner')
}

export const registerScannerHandlers = (onScan, onError) => {
  if (isTestMode()) {
    window.FAKE_SCANNER = {
      scan: (data) => {
        onScan(data)
      },
    }
  }

  const bridgeInstance = PeripheralBridge.getBridge()
  if (!bridgeInstance) return

  bridgeInstance.registerHandler('scanPayload', (data) => {
    if (onScan) {
      onScan(data)
    }
  })

  bridgeInstance.registerHandler('scanError', (err) => {
    if (onError) {
      onError(err)
    }
  })
}

export const unRegisterScannerHandlers = () => {
  if (isTestMode()) {
    delete window.FAKE_SCANNER
  }

  const bridgeInstance = PeripheralBridge.getBridge()
  if (!bridgeInstance) return

  bridgeInstance.registerHandler('scanPayload', () => {})
  bridgeInstance.registerHandler('scanError', () => {})
}
